/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Accept_NecessaryInputs */

const en_cookies_accept_necessary = /** @type {(inputs: Cookies_Accept_NecessaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessary only`)
};

const pl_cookies_accept_necessary = /** @type {(inputs: Cookies_Accept_NecessaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko niezbędne`)
};

/**
* | output |
* | --- |
* | "Necessary only" |
*
* @param {Cookies_Accept_NecessaryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_accept_necessary = /** @type {((inputs?: Cookies_Accept_NecessaryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Accept_NecessaryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_accept_necessary(inputs)
	return en_cookies_accept_necessary(inputs)
});